module.exports = __webpack_public_path__ + "static/media/foto_3.7b7e1c47.png";